import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBVLQJivIjl-pUMobCX_Q7Qb7mZZ22tYpg",
  authDomain: "cloudairambo-a4f83.firebaseapp.com",
  projectId: "cloudairambo-a4f83",
  storageBucket: "cloudairambo-a4f83.firebasestorage.app",
  messagingSenderId: "311095185790",
  appId: "1:311095185790:web:29eb128b7f9da77877a32f"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
